import styled from "styled-components";
import { ModalType } from "./index";

export const WrapperContent = styled.div`
  box-sizing: border-box;
  padding: 12px;
`
export const ModalText = styled.p`
  font-size: 16px;
  color: var(--color-contrast-brand);
  margin: 12px 0px;
  padding: 4px 0px 4px 0px;
`

interface WrapperButtonsProps {
  modalType?: ModalType;
}

export const WrapperButtons = styled.div<WrapperButtonsProps>`
  display: flex;
  justify-content: end;
  padding-top: 24px;
  ${({ modalType }) =>
    modalType === ModalType.Danger ?
      `.danger-btn {
        background: #DE4246 !important;
        color: #fff !important;
        &:hover {
          background-color: #eb140c !important;
          color: #fff !important;
        }
      }` : ''
  }
`;

interface ModalTitleProps {
  modalType?: ModalType;
}

export const ModalTitle = styled.p<ModalTitleProps>`
  font-weight: var(--font-weight-semibold);
  font-size: 18px;
  line-height: 20px;
  margin: 8px 0px 12px 0px;
  color: ${({ modalType }) =>
    modalType === ModalType.Danger ? '#DE4246' : 'var(--color-action-default)'};
`;